import { render, staticRenderFns } from "./ArticleRibbons.vue?vue&type=template&id=491231df&scoped=true"
import script from "./ArticleRibbons.vue?vue&type=script&lang=ts"
export * from "./ArticleRibbons.vue?vue&type=script&lang=ts"
import style0 from "./ArticleRibbons.vue?vue&type=style&index=0&id=491231df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491231df",
  null
  
)

export default component.exports